/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WwalkinManagerDisplay {
    angular.module("meevo.plugins.walkinManagerDisplay", []);
}